export default __webpack_public_path__ + "static/media/app.20ba726c.png";